import moment from "moment";

const UTILS = {
  userGreeting: () => {
    let d = new Date();
    let time = d.getHours();
    if (time < 12) {
      return "Good Morning";
    }
    if (time >= 12 && time < 16) {
      return "Good Afternoon";
    }
    return "Good Evening";
  },
  descendingComparator: (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  },

  getComparator: (order, orderBy) => {
    return order === "desc"
      ? (a, b) => UTILS.descendingComparator(a, b, orderBy)
      : (a, b) => -UTILS.descendingComparator(a, b, orderBy);
  },

  stableSort: (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  },
};

export const objectToString = (array, separator) => {
  return Object.keys(array)
    .map((key) => key + "=" + array[key])
    .join(separator);
};

export const getFilterDataByMenu = (existingFilter, menuUrl) => {
  const filterData = existingFilter.find(
    (filter) => filter.menuUrl === menuUrl
  );
  return filterData;
};

export const getFilterData = (
  existingFilter = [],
  menuUrl,
  type = "queryString"
) => {
  const extFilter = existingFilter || [];
  const filterData = extFilter.find((filter) => filter.menuUrl === menuUrl);
  if (type === "filter") return filterData?.filters || null;
  if (filterData) {
    // filterData.filter.reduce((x, y) => ((x[y] = 1), x), {});
    const initialValue = {};
    const queryString = filterData.filters.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item["value"],
      };
    }, initialValue);
    return queryString ? "&" + objectToString(queryString, "&") : "";
  }
  return {};
};

export const checkFilterForValue = (filters) => {
  let filterFound = false;
  if (filters && filters.length > 0)
    for (let i = 0; i < filters.length; i++)
      if (filters[i].value != "") filterFound = true;
  return filterFound;
};

export const getMenuFilters = (allFilterList, menuUrl) => {
  return allFilterList.find((filter) => filter.menuUrl === menuUrl);
};

const formatFilterValue = (filter) => {
  if (
    filter.type === "autocomplete" &&
    filter.isMultiple &&
    filter.value &&
    filter.value.length > 0
  ) {
    const valArray = filter.value.map((val) => val.value);
    return valArray.toString();
  }
  return filter.value;
};

export const filtersToQuery = (filters) => {
  const initialValue = {};
  const queryString = filters.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: formatFilterValue(item),
    };
  }, initialValue);
  return queryString ? "&" + objectToString(queryString, "&") : "";
};

export const constructFilterData = (existingFilter, menuUrl, filterData) => {
  let filterArray = existingFilter.map((filter) => {
    return {
      ...filter,
    };
  });
  const filterCheckIndex = existingFilter.findIndex(
    (filter) => filter.menuUrl === menuUrl
  );
  // console.log({ filterCheckIndex });
  if (filterCheckIndex > -1) {
    filterArray[filterCheckIndex].filters = filterData;
  } else filterArray.push({ menuUrl, filters: filterData });
  // console.log({ filterArray });
  return filterArray;
};

export const dateStringToObject = (dateStr) => {
  const dateTimeArray = dateStr.split(" ");
  const dateArray = dateTimeArray[0].split("-");
  // const formatedDate = dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2];
  //
  // return formatedDate;

  // console.log(
  //   dateArray,
  //   dateArray[0] + "/" + dateArray[1] + "/" + dateArray[2],
  //   moment(dateArray[0] + "-" + dateArray[1] + "-" + dateArray[2])
  // );

  // // console.log(dayjs(dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]));
  // return dayjs(dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]);
  // return moment(dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]);
  const dateObject = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
  // const dateObject = new Date(dateArray[0] + '/' + dateArray[1] + '/' + dateArray[2]);
  // console.log(dateObject);
  return dateObject;
};

export default UTILS;

export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary75: "red",
    primary50: "#7367f0",
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});
